import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useLocation,
} from "react-router-dom";

import './App.css';
import composers from './composers';

import filterComposers from './helpers/filterComposers';

import HeaderComposerList from './components/HeaderComposerList'
import WorksByComposerIndex from './components/WorksByComposerIndex'
import WorksByRecentlyAdded from './components/WorksByRecentlyAdded';

function Main({filter, composers}) {
  let filteredComposers = [];
  if (filter === 'favorite') {
    filteredComposers = filterComposers(composers)
  } else {
    filteredComposers = composers;
  }

  filteredComposers = filteredComposers.filter((element) => {
    return element !== undefined;
  });

  const search = useLocation().search;
  const orderBy = new URLSearchParams(search).get('orderBy');

  // get "nativeLinks"
  let nativeLinks = new URLSearchParams(search).get('nativeLinks');
  nativeLinks = nativeLinks === "true" ? true : false;

  let orderByComposerIndexLink = '';
  let orderByRecentLink = '';
  if (filter === 'all') {
    orderByComposerIndexLink = `/all?orderBy=composerIndex&nativeLinks=${nativeLinks}`;
    orderByRecentLink = `/all?orderBy=recentlyAdded&nativeLinks=${nativeLinks}`;
  } else if (filter === 'favorite') {
    orderByComposerIndexLink = `/favorite?orderBy=composerIndex&nativeLinks=${nativeLinks}`;
    orderByRecentLink = `/favorite?orderBy=recentlyAdded&nativeLinks=${nativeLinks}`;
  }

  const currentlyOrderingBy = orderBy ? orderBy : 'composerIndex';

  return (
    <div id="main">
      <div className="filter">
        <div className="linkContainer">
          <div className="linkRow">
            <span>Order by</span>
            <Link className={`link ${currentlyOrderingBy === 'composerIndex' ? 'activeLink' : ''}`} to={orderByComposerIndexLink}>Composer Index</Link>
            <Link className={`link ${currentlyOrderingBy === 'recentlyAdded' ? 'activeLink' : ''}`} to={orderByRecentLink}>Recently Added</Link>
          </div>
          <div className="linkRow">
            <Link className={`link ${filter === 'all' ? 'activeLink' : ''}`} to={`/all?orderBy=${currentlyOrderingBy}&nativeLinks=${nativeLinks}`}>All</Link>
            <Link className={`link ${filter === 'favorite' ? 'activeLink' : ''}`} to={`/favorite?orderBy=${currentlyOrderingBy}&nativeLinks=${nativeLinks}`}>Favorite</Link>
          </div>
        </div>
      </div>

      {/* pass "nativeLinks" down THROUGH the navigation links */}
      {
        currentlyOrderingBy === 'composerIndex'
          ? <WorksByComposerIndex composers={filteredComposers} nativeLinks={nativeLinks} />
          : null
      }
      {
        currentlyOrderingBy === 'recentlyAdded'
        ? <WorksByRecentlyAdded composers={filteredComposers} nativeLinks={nativeLinks} />
        : null
      }


      <p><a href="https://icons8.com/icon/32480/deezer">Deezer icon by Icons8</a></p>
      <p><a href="https://icons8.com/icon/63316/spotify">Spotify icon by Icons8</a></p>
      <p><a href="https://icons8.com/icon/121115/apple-music">Apple Music icon by Icons8</a></p>
    </div>
  )
}

// TODO: on mobile, SIDE should function as a DROP-DOWN, that comes from the TOP of the screen and is an OVERLAY on the regular list!!
function Side({composers}) {
  return (
    <div id="side">
      <HeaderComposerList composers={composers} />
    </div>
  )
}

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/all">
          <div id="page">
            <Side composers={composers} filter={'all'}/>
            <Main composers={composers} filter={'all'}/>
          </div>
        </Route>
        <Route path="/favorite">
          <div id="page">
            <Side composers={composers} filter={'favorite'} />
            <Main composers={composers} filter={'favorite'} />
          </div>
        </Route>
        <Route path="/">
          <div id="page">
            <Side composers={composers} filter={'all'}/>
            <Main composers={composers} filter={'all'}/>
          </div>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
